import { initAppAnalytics } from "@hamdevco/analytics/app";
// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./bulk_select_fixes"

// PostHog for the authenticated product. Ingest is proxied same-origin at
// /ingest by IngestController. The token is a literal: a phc_ project key is
// public by design and must reach the browser either way.
initAppAnalytics({
  token: "phc_r8BXeJzU4YtXWfC3xTEcm6DFXugJjK8VinQF2fQbBX43", // HamDevCo Web (590688)
  app: "seoknows",
  owner: "hamdevco",
});
